export class AdditionalInformation{
  additionalInformation:string = '';
  notes:string = '';
}
